
// src/web/components/loading.jsx

import React from 'react'
import ProgressBar from 'react-toolbox/lib/progress_bar'

export default function Loading(props) {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ProgressBar type='circular' multicolor mode='indeterminate' />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/web/components/loading.jsx